import type { ReactNode } from "react";

// 전역 safe-area 래퍼 — iOS notch + Android gesture bar 대응
// Codex 권고: position:fixed 하단 UI가 가려지는 함정을 root에서 차단
export function SafeAreaLayout({ children }: { children: ReactNode }) {
  return <div className="safe-area-root">{children}</div>;
}
